import { useMutation } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import type { ExportOrganizationUsagePdfParams } from '../../api/queries';

export const useExportOrganizationUsagePdfMutation = () => {
  const { exportOrganizationUsagePdf } = useServicesContext();

  return useMutation({
    mutationFn: (params: ExportOrganizationUsagePdfParams) =>
      exportOrganizationUsagePdf(params),
  });
};
